import { MdOutlinePhoneInTalk } from "react-icons/md";
import { BasketIcon, SalesIcon } from "../assets/icons/audio-icons";

export default {
  total_calls: {
    description: "Total Calls",
    icon: MdOutlinePhoneInTalk,
    text_color: "text-white",
    kpi_text_color: "text-primary",
    bg_color: "bg-primary",
  },
  // outgoing_calls_count: {
  //   description: "Outgoing calls",
  //   subtitle: "day",
  //   icon: PhoneAltIcon,
  //   text_color: "text-white",
  //   bg_color: "bg-primary",
  // },
  total_revenue: {
    description: "Total Sales",
    icon: SalesIcon,
    text_color: "text-white",
    kpi_text_color: "text-primary",
    bg_color: "bg-primary",
  },
  average_revenue: {
    description: "Average sales",
    subtitle: "day",
    icon: BasketIcon,
    text_color: "text-white",
    kpi_text_color: "text-primary",
    bg_color: "bg-primary",
  },
};
